export default __webpack_public_path__ + "static/media/Pistol_4.78fe6f5a.png";